<template>
  <div>
    <!-- 顶部导航 -->
    <TopNav></TopNav>
    <!-- 智能家居轮播图 -->
    <HomeFurnishingBanner></HomeFurnishingBanner>
    <!-- 一键开启智能家居生活 -->
    <Describe></Describe>
    <!-- 多种智能家居硬件设备 -->
    <HouseholdEquipment></HouseholdEquipment>
    <!-- 底部导航 -->
    <ButtonNav></ButtonNav>
  </div>
</template>

<script>
import { reactive } from "vue";

import TopNav from "../../../../components/pc/components/TopNav.vue";
import ButtonNav from "../../../../components/pc/components/BottomNav.vue";
import HomeFurnishingBanner from '../../../../components/pc/Programme/HomeFurnishingComponents/HomeFurnishingBanner.vue'
import Describe from '../../../../components/pc/Programme/HomeFurnishingComponents/Describe.vue'
import HouseholdEquipment from '../../../../components/pc/Programme/HomeFurnishingComponents/HouseholdEquipment.vue'

export default {
  setup() {
    return reactive({});
  },
  components: {
    TopNav,
    ButtonNav,
    HomeFurnishingBanner,
    Describe,
    HouseholdEquipment,
  },
};
</script>

<style scoped>
</style>
